<article class="card-insight" [ngClass]="severityClass">
  <span class="card-insight__stem" aria-hidden="true"></span>

  <header class="card-insight__head">
    <span class="card-insight__pill" [ngClass]="pillClass">
      <span class="card-insight__pill-glyph" aria-hidden="true">{{ severityGlyph(severity) }}</span>
      <span>{{ severityLabelKey(severity) | translate }}</span>
    </span>
    <h3 class="card-insight__headline" [innerHTML]="headline | novaMarkdown"></h3>
  </header>

  <div class="card-insight__observation card-markdown" [innerHTML]="observation | novaMarkdown"></div>

  <div class="card-insight__action" *ngIf="insightAction">
    <ion-icon name="arrow-forward-circle" class="card-insight__action-glyph" aria-hidden="true"></ion-icon>
    <div class="card-insight__action-body card-markdown" [innerHTML]="insightAction | novaMarkdown"></div>
  </div>

  <div class="card-insight__tools" *ngIf="tools?.length">
    <span class="card-insight__chip" *ngFor="let tool of tools; trackBy: trackTool">
      <ion-icon name="cube-outline" aria-hidden="true"></ion-icon>
      {{ tool }}
    </span>
  </div>

  <card-actions
    *ngIf="actions?.length"
    [actions]="actions"
    (action)="onAction($event)">
  </card-actions>
</article>
